
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class ImageOverlayEffect extends BaseParallaxEffect implements ParallaxEffect {
    private imageCache: Map<string, HTMLImageElement> = new Map();

    public render(pc: ParallaxContext): void {
        const { ctx, config, width, height } = pc;
        const url = config.parallaxImageUrl;
        if (!url) return;

        let img = this.imageCache.get(url);
        if (!img) {
            img = new Image();
            img.src = url;
            img.referrerPolicy = "no-referrer";
            this.imageCache.set(url, img);
        }

        if (img.complete) {
            ctx.save();
            ctx.globalAlpha *= (config.parallaxMediaOpacity || 1.0);
            
            const fit = config.parallaxMediaFit || 'COVER';
            this.drawMedia(ctx, img, width, height, fit);
            
            ctx.restore();
        }
    }

    private drawMedia(ctx: CanvasRenderingContext2D, img: HTMLImageElement, w: number, h: number, fit: string) {
        let dx = -w/2, dy = -h/2, dw = w, dh = h;
        const imgAspect = img.width / img.height;
        const screenAspect = w / h;

        if (fit === 'COVER') {
            if (imgAspect > screenAspect) {
                dw = h * imgAspect;
                dx = -dw / 2;
            } else {
                dh = w / imgAspect;
                dy = -dh / 2;
            }
        } else if (fit === 'CONTAIN') {
            if (imgAspect > screenAspect) {
                dh = w / imgAspect;
                dy = -dh / 2;
            } else {
                dw = h * imgAspect;
                dx = -dw / 2;
            }
        }
        // STRETCH is default dx, dy, dw, dh

        ctx.drawImage(img, dx, dy, dw, dh);
    }
}
